import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const CardIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <g id="Icon / Library">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.04163 6.91733C2.04163 4.83513 3.65807 3.08398 5.72814 3.08398H15.2718C17.3419 3.08398 18.9583 4.83513 18.9583 6.91733V13.084C18.9583 15.1662 17.3419 16.9174 15.2718 16.9174H5.72814C3.65807 16.9174 2.04163 15.1662 2.04163 13.084V6.91733ZM5.72814 4.58398C4.55463 4.58398 3.54163 5.59375 3.54163 6.91733V7.709L17.4583 7.709V6.91733C17.4583 5.59375 16.4453 4.58398 15.2718 4.58398H5.72814ZM17.4583 9.209L3.54163 9.209V13.084C3.54163 14.4076 4.55463 15.4174 5.72814 15.4174H15.2718C16.4453 15.4174 17.4583 14.4076 17.4583 13.084V9.209Z"
          fill="#222222"
        />
      </g>
    </svg>
  );
};
